import { CancelToken } from 'axios';
import { BaseApi } from './BaseApi';

export default class AdSpaces extends BaseApi {
  public async updateAsync(adSpace: IAdSpace) {
    await this.putAsync('adspaces/' + adSpace.adSpaceId, adSpace);
  }
}
